
import dynamic, { type Loader } from 'next/dynamic'
import React, { ComponentType, FC } from 'react'
import { deviceDetector } from '../uaDevicesParse';
import { LazyHydrateOptions, ComponentProps } from './types';
import { hydrateFunction } from './hydrateFunction';

function lazyHydrate<P = object>(
  loader: Loader<P>,
  options?: LazyHydrateOptions<P>,
): React.ComponentType<P & ComponentProps>{
  const {
    observerOptions,
    idleOptions,
    displayImmediatelyOnPC = false,
    returnLoadingFunction = false,
  } = options ?? {}

  const { wrapperElement, serverJsx = undefined} = observerOptions ?? {}

  const Component = dynamic(loader, {
    ssr: options?.ssr ?? true,
    loading: options?.loading,
  })
  const isServer = typeof window === 'undefined'

  if(isServer) {
    if(options?.ssr) {
      if(!!wrapperElement || !!serverJsx) {
          return (({ wrapperProps = {}, ...props }: P & ComponentProps) => {
            if (React.isValidElement(serverJsx)) {
              return serverJsx
            }
            const WrapperElement = wrapperElement as unknown as FC<React.HTMLProps<HTMLElement>>
            return (
              <WrapperElement {...wrapperProps}>
                <Component {...props as any} />
              </WrapperElement>
            )
          }) as React.ComponentType<P & ComponentProps>
      }
      return Component as unknown as FC<P>
    }
    return Component as unknown as FC<P>
  }else{
    if(displayImmediatelyOnPC && deviceDetector.isLocalPC()){
      return Component as unknown as FC<P>
    }
    // 如果启用开关且 loading 为函数，则直接返回 loading 函数
    if (returnLoadingFunction && typeof options?.loading === 'function') {
      return options.loading as unknown as React.ComponentType<P & ComponentProps>
    }
    return hydrateFunction(Component as ComponentType<Omit<P & ComponentProps, 'wrapperProps'>>, {
        idleOptions: idleOptions,
        observerOptions: observerOptions,
      }) as React.ComponentType<P & ComponentProps>
  }
}

export { lazyHydrate }
export type { LazyHydrateOptions }